export class ArchivoDescargaMasiva{
    archivosXml: number[]=[];
    archivosPdf: number []=[];
}